import guid from '@/lib/guid';
import {encode, decode} from '@/lib/common';
//import * as Papa from 'papaparse';
import ApiService from '@/services/api.service';
//import dayjs from 'dayjs';
import trim from 'voca/trim';
import pluralize from 'pluralize';

//import alasql from "alasql";
//alasql.fn.moment = dayjs;
const table = 'datasources';
const responseTable = 'responses';
import {getFromStorage, saveInStorage, removeFromStorage, clearStorage} from '@/services/localstorage.service';

//const schema = {datasources: "id,name,description,projectId"};
/**
import {
  db
} from '@/services/db.js';**/

//version.stores(schema);
/**
db.open();

db.tables.forEach(function (table) {
    console.log("table : " + table.name);
    console.log(db[table.name]);
});
**/


let config = {
  delimiter: "", // auto-detect
  newline: "", // auto-detect
  quoteChar: '"',
  escapeChar: '"',
  header: true,
  transformHeader: undefined,
  dynamicTyping: false,
  preview: 0,
  encoding: "",
  worker: true,
  comments: false,
  step: undefined,
  complete: undefined,
  error: undefined,
  download: false,
  skipEmptyLines: true,
  chunk: undefined,
  fastMode: undefined,
  beforeFirstChunk: undefined,
  withCredentials: undefined,
  transform: undefined
  //delimitersToGuess: [',', '\t', '|', ';', Papa.RECORD_SEP, Papa.UNIT_SEP]
};



function pasteUpdate(d) {
  let dataSource = {};
  return new Promise(function(resolve, reject) {
    transformPaste(d).then(function(result) {
      Object.freeze(result.data);
      const size = result.data.length;
      const filteredData = result.data.slice(0, d.pageSize);
      dataSource.data = result.data;
      dataSource.size = size;
      dataSource.filteredData = filteredData;
      dataSource.headers = result.headers;
      dataSource.loading = false;
      dataSource.updated = true;
      dataSource.fullQuery = null;
      dataSource.query = null;
      resolve(dataSource);
    }).catch(function(err) {

      reject(err);
    });
  });
}

async function apiUpdate(d, columnNames) {
  // console.log("d", d);
  let params = {};
  params.rowsPerPage = d.pageSize;
  let dataSource = {sqlError: null};

  try {

  if(d.cacheable && typeof d.list != 'undefined' && typeof d.list.totalItems != "undefined" && d.list.totalItems > 1) {
    return new Promise(function(resolve, reject) {
      dataSource.data = d.list.results;
      dataSource.size = d.list.totalItems;
      dataSource.filteredData = dataSource.data;
      dataSource.headers = extractHeaders(dataSource.data, columnNames);
      dataSource.loading = false;
      dataSource.updated = true;
      dataSource.fullQuery = d.list.fullQuery;
      dataSource.query = d.list.query;
    resolve(dataSource);
    });
  }

  return new Promise(function(resolve, reject) {
    ApiService.query('/datasource/list/' + d.id, {
      params: params
    }).then(function(response) {
      // const response = await ApiService.query('/files/list/' + d.id, {params: params});
      dataSource.data = response.data.results;
      dataSource.size = response.data.totalItems;
      dataSource.filteredData = dataSource.data;
      dataSource.headers = extractHeaders(dataSource.data, columnNames);
      dataSource.loading = false;
      dataSource.updated = true;
      dataSource.fullQuery = response.data.fullQuery;
      dataSource.query = response.data.query;

      resolve(dataSource);
    }).catch(function(error) {

      let sqlError =  'ERROR: fetching data';

      try {
        sqlError = error.response.data.message;
      } catch(e) {

      }

      dataSource = {sqlError: sqlError};
      reject(dataSource);
    });

  });
} catch(error) {
  // console.log("error", error);
  return new Promise(function(resolve, reject) {
    reject(dataSource);
  });
}
}
let queryCache = {};

async function resultRequest(path, params) {
  //let params = {};
  // String key = params
  let dataSource = {};
  if(typeof params.rowsPerPage == "undefined") {
    params.rowsPerPage = 10000;
  }

  return new Promise(function(resolve, reject) {
    ApiService.query(path, {
      params: params
    }).then(function(response) {
      resolve(response.data);
    }).catch(function(err) {
      reject(err);
    });

  });
}

async function apiSQLDownload(pp, columnNames) {
  let params = {...pp};
  params.sql = window.btoa(params.sql);
  params.pre = 1;
  params.columnNames = columnNames;

  return ApiService.post('/datasource/downloadsql/' + params.id, params);

}

async function apiSQLUpdate(pp, columnNames) {
  //let params = {};
  // String key = params
  let dataSource = {sqlError: null};
  let params = {...pp};
  params.sql = window.btoa(params.sql);
  params.pre = 1;

  if(typeof params.rowsPerPage == "undefined") {
    params.rowsPerPage = 10000;
  }

  // console.log('apiSQLUpdate params', params);

  // params.rowsPerPage = 1000;
  const queryId = '/datasource/sql/' + params.id + JSON.stringify(params);
  // let localCopy = getFromStorage(queryId);
  let localCopy = null;
  // console.log("query id", queryId);

  return new Promise(function(resolve, reject) {
    if(typeof pp["realtime"] != "undefined" && pp["realtime"] == true) {

    } else if(typeof queryCache[queryId] != "undefined") {
      // console.log("using query cache");
      resolve(queryCache[queryId]);
      return true;
    } else if(localCopy) {

      //appendResponseToDataSource(dataSource, JSON.parse(localCopy), columnNames);
      //resolve(dataSource)
      // return true;
    //  let cValue = getFromStorage(queryId);
      //if(cValue)
    }
    ApiService.post('/datasource/postsql/' + params.id, params).then(function(response) {
      // console.log("api response ", response);

      // const response = await ApiService.query('/files/list/' + d.id, {params: params});
      /**
      dataSource.data = response.data.results;
      dataSource.size = response.data.totalItems;
      dataSource.filteredData = dataSource.data;
      dataSource.headers = extractHeaders(dataSource.data, columnNames);
      dataSource.loading = false;
      dataSource.updated = true;
      dataSource.fullQuery = response.data.fullQuery;
      dataSource.query = response.data.query;**/

      appendResponseToDataSource(dataSource, response, columnNames);

      // queryCache[queryId] = dataSource;
      try {
        // saveInStorage(queryId, JSON.stringify(response));
      } catch(err) {
        // 
      }

      resolve(dataSource);
    }).catch(function(error) {

      let sqlError =  'ERROR: fetching data';

      try {
        sqlError = error.response.data.message;
      } catch(e) {
        //
      }

      dataSource = {sqlError: sqlError};
      dataSource.data = [];
      dataSource.size = 0;
      dataSource.filteredData = dataSource.data;
      dataSource.headers = extractHeaders(dataSource.data, columnNames);
      dataSource.loading = false;
      dataSource.updated = true;
      dataSource.fullQuery = '';
      dataSource.query = '';



      // console.log("dataSource.sqlError", dataSource.sqlError);
      // dataSource.sqlError = '';
      resolve(dataSource);
    });

  });
}


function appendResponseToDataSource(dataSource, response, columnNames) {
  dataSource.data = response.data.results;
  dataSource.size = response.data.totalItems;
  dataSource.filteredData = dataSource.data;
  dataSource.headers = extractHeaders(dataSource.data, columnNames);
  dataSource.loading = false;
  dataSource.updated = true;
  dataSource.fullQuery = response.data.fullQuery;
  dataSource.query = response.data.query;
}

// let SqlApiExecutor = {};
// SqlApiExecutor.cache = queryCache;
// apiSQLUpdate.get = apiSQLUpdate;

function sqlUpdate(d) {
  return new Promise(function(resolve, reject) {
    let dataSource = {}
    transformSQL(d, d.dataSources).then(function(result) {
      Object.freeze(result.data);
      const size = result.data.length;
      const filteredData = result.data.slice(0, d.pageSize);
      dataSource.data = result.data;
      dataSource.size = result.totalItems;
      dataSource.filteredData = filteredData;
      dataSource.headers = result.headers;
      dataSource.loading = false;
      dataSource.updated = true;
      dataSource.fullQuery = null;
      dataSource.query = null;
      resolve(dataSource);
    }).catch(function(err) {

      reject(err);
    });
  });
}

const updateTypes = {
  'sql': sqlUpdate,
  'paste': pasteUpdate,
  'api': apiUpdate
};


export class DataSource {
  constructor({
    id = null,
    name = `Sheet`,
    loading = false,
    columnId = "",
    content = null,
    projectId = 0,
    parent = null,
    parentId = null,
    description = '',
    error = null,
    message= null,
    input = '',
    headers = [],
    baseQuery = null,
    type = `default`,
    list = {},
    data = [],
    columns = [],
    columnNames = null,
    properties = null,
    userId = null,
    schema = null,
    options = null,
    status = null,
    relationships = [],
    parents = [],
    children = []
  } = {}) {

    this._parameters = {
      id: id,
      name: name,
      loading: loading,
      columnId: columnId,
      content: content,
      projectId: projectId,
      parent: parent,
      parentId: parentId,
      description: description,
      input: input,
      headers: headers,
      type: type,
      list: list,
      data: data,
      columns: columns,
      columnNames: columnNames,
      properties: properties,
      userId: userId,
      schema: schema,
      options: options,
      status: status,
      relationships: relationships,
      parents: parents,
      children: children
    };
    // types : datasource, dataframe
    this.id = id;
    if (!this.id) {
      this.id = guid.createId('datasource');
    }
    input = schema ? schema : input;
    this.type = type;
    this.name = trimName(name);
    this.parent = parent;
    this.headers = headers;
    this.description = description;
    this.loading = loading;
    this.input = input;
    this.projectId = projectId;
    this.columnId = columnId;
    this.dataSources = [];
    this.parentId = parentId;
    this.sqlError = null;

    this.list = list;
    this.data = data;
    this.userId = userId;
    this.size = 0;
    this.pageSize = 1;
    this.updated = false;
    this.status = status;

    this.baseQuery = baseQuery;

    this.relationships = relationships;
    this.children = children;
    this.parents = parents;

    this.childrenIds = [];

    this.cacheable = false;


    this.fullQuery = null;
    this.query = null;
    this.columnNames = null;
    try {
      this.columnNames = JSON.parse(columnNames);
    } catch(err) {
      this.columnNames = this.columnNames;
    }

    this.options = {
      selectedFields: [],
      mergedTables: []
    };
    // console.log("columnNames", this.columnNames);
    this.cachedRequests = {};

    this.updateType = type;

    if (type.startsWith("union_") || type.startsWith("jdbc")) {
      this.updateType = "api";
    }

    this.filteredData = [];

    if (input != '') {
      try {
        this.input = decode(input);
      } catch (err) {
        this.input = input;
      }
    }

    this.listPossibleMergeDataSources = [];

    //console.log("parameter options", options);
    if (options != null) {
      try {
        this.options = decode(options);

        if(this.options && typeof this.options.selectedFields == "undefined") {
          this.options = {
            selectedFields: [],
            mergedTables: []
          };
        }

      } catch (err) {
        this.options = options;

        if(this.options && typeof this.options.selectedFields == "undefined") {
          this.options = {
            selectedFields: [],
            mergedTables: []
          };
        }
      }

    }

    // console.log("this.options", this.options);
    if (content != null) {
      try {
        this.setData(decode(content));
      } catch (err) {
        this.setData(content);
      }

    }

    if (!this.properties) {
      this.properties = {
        colHeaders: true,
        rowHeaders: true
      };
    }
  }
  setUpdateType() {
    if (this.type.startsWith("union_") || this.type.startsWith("jdbc")) {
      this.updateType = "api";
    }
  }
  setData(data) {
    this.data = data;
    // Object.freeze(data);
    // this.size = data.length;
    // this.filteredData = this.size > 0 ? data.slice(0, this.pageSize) : [];
    // this.data = data;
    //  this.filteredData = data;
    // this.headers = extractHeaders(data);
  }
  resultRequest(path, query) {
    return resultRequest(path, query);
  }
  request(query) {
    if (this.updateType == "api") {
      if(typeof query.realtime == "undefined") {
        query.realtime = true;
      }

      return apiSQLUpdate(query, this.columnNames);
    }
    // cachedRequests
  }
  download(query) {
    return apiSQLDownload(query, this.columnNames);
  }
  loadMergedWorksheets(dataSources) {

    this.listPossibleMergeDataSources = [];
    this.options.mergedTables = [];
    this.childrenIds = [];

    // console.log(this);
    // console.log("this.children", this.children);

    for(let i = 0; i < this.children.length; i++) {
      //console.log("this.children[i].", this.children[i]);
      this.childrenIds.push(this.children[i].datasourceId);
    }


    if(this.type == 'union_view') {
      for(let i = 0; i < dataSources.length; i++) {

        let dataSource = dataSources[i];
        if(dataSource.type != 'union_view' && dataSource.columnId == this.columnId) {
          // if it does not have an id
        //  if(!dataSource.parentId) {
        //    this.listPossibleMergeDataSources.push(dataSource);
        //  }
        //  if(dataSource.parentId && dataSource.parentId == this.id) {
            // console.log("dataSource.parentId", dataSource.parentId);
            this.listPossibleMergeDataSources.push(dataSource);
          //  this.options.mergedTables.push(dataSource.id);
        //  }
        }
      }
    }

  }
  getStorageKey() {
    return 'datasource' + '.' + this.projectId;
  }
  saveInStorage() {
    saveInStorage(this.getStorageKey(), this.id);
  }
  clone() {
    return new DataSource(this._parameters);
  }
  update(useCache) {

    // console.log("calling update");
    this.setUpdateType();
    let that = this;
    return new Promise(function(resolve, reject) {
      // console.log("attameting update", that.updateType);
      //   console.log("updating datasource");
      // console.log()

      if (typeof useCache !== "undefined" && useCache && that.updated) {
        // console.log("use cache", "here");
        resolve(true);
        return true;
      }

      that.data = [];
      that.filteredData = [];
      that.headers = [];
      that.loading = false;


      if (updateTypes.hasOwnProperty(that.updateType)) {
        // console.log("updating datasource in progress " + this.updateType);
        // console.log("type : " + dataSource.type);
        updateTypes[that.updateType](that, that.columnNames).then(function(result) {
          that.data = result.data;
          that.size = result.size;
          that.filteredData = result.filteredData;
          that.headers = Object.freeze(result.headers);
          that.loading = result.loading;
          that.updated = result.updated;
          that.fullQuery = result.fullQuery;
          that.query = result.query;
          that.updated = true;
          that.sqlError = result.sqlError;
          resolve(true);
          // console.log("updating", that.updateType);

        }).catch(function(err) {
          // console.log("could not update", that.updateType);
          // console.log("error", err);
          // if(typeo)
          that.sqlError = err.sqlError;
          that.data = [];
          that.filteredData = [];
          that.headers = [];
          that.loading = false;
          that.updated = false;
          that.fullQuery = null;
          that.query = null;
          reject(err);
        });
      }
    });
  }
}

function trimName(name) {
  return trim(trim(trim(name, "\""), "'"));
}
export function createDataSource(data) {
  return new DataSource(data);
}

export function createDataSourceFromString(csvString) {


  // return Papa.parse(csvString, config);
}

function getType(key, list, length, alias) {
  // const dateFormat = "YYYY-MM-DD "
  key = key.toLowerCase();
  if (typeof alias == "undefined") {
    alias = key;
  }
  alias = alias.toLowerCase();
  let types = {
    'date': {
      type: "date",
      points: 0,
      names: "date dt weekenddate"
    },
    'time': {
      type: "time",
      points: 0,
      names: "starttime endtime start_time end_time"
    },
    'person': {
      type: "person",
      points: 0,
      names: "employee person fullname name customer name sales person candidatefirstname"
    },
    'organisation': {
      type: "organisation",
      points: 0,
      names: "company organisation organization clientname"
    },
    'department': {
      type: "department",
      points: 0,
      names: "department"
    },
    'note': {
      type: "note",
      points: 0,
      names: "note comment"
    },
    'location': {
      type: "location",
      points: 0,
      names: "country city state region"
    },
    'money': {
      type: "money",
      points: 0,
      names: "profit revenue salary pay sales quantity discount profit"
    },
    'percent': {
      type: "percent",
      points: 0,
      names: "percent ration"
    },
    'text': {
      type: "text",
      points: 20
    },
    'numeric': {
      type: "numeric",
      points: 20
    },
    'id': {
      type: "id",
      points: 0
    }
  };

  // isNaN('Hello')


  Object.entries(types).forEach(([i, type]) => {
    // console.log(types[i]);
    // console.log(alias);
    if (typeof types[i].names != "undefined" && types[i].names.includes(pluralize.singular(alias))) {
      types[i].points += 30;
    }
  });
  length = list.length < length ? list.length : length;
  var re = /^\d{4}-\d{1,2}-\d{1,2}.*$/;
  for (let i = 0; i < length; i++) {
    // console.log(key);
    const val = list[i][key];
    // const d = moment(val);


    if (re.test(val)) {
      types["date"].points += 10;
    }
    if (val && !isNaN(val)) {
      types["numeric"].points += 10;
    }
  }

  return Object.values(types).sort(function(a, b) {
    return b.points - a.points;
  });

}

function humanize(str) {
  var i, frags = str.split('_');
  for (i=0; i<frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(' ');
}
const capitalize = (s) => {
  if (typeof s !== 'string') return s;
  // return s.charAt(0).toUpperCase() + s.slice(1)
  return humanize(s);
}

function getName(columnNames, value) {
  try {
    if(typeof columnNames[value] != "undefined") {
      return columnNames[value].name;
    }
  } catch(err) {
    // 
  }

  return capitalize(value.replace("_native", ""));
}

function extractHeaders(data, columnNames) {
  if(typeof columnNames == "undefined" || !columnNames) {
    columnNames = {};
  }
  let headers = [];
  const ignoreFields = {
    "_nativefilename": true,
    "_nativeupdated": true,
    "_nativeupdatedby": true,
    "_nativecreated": true,
    "nativecreatedby": true,
    "_nativedatasource": true,
    "_nativedatasourceid": true,
    "_nativeid": true,
    "__nativeid": true
  };
  if (data.length) {
    const headersArray = Object.keys(data[0]);

    headersArray.forEach(function(value, index) {
      if (typeof ignoreFields[value] == "undefined") {
        const types = getType(value, data, 10);
        // console.log(value + " value is ", types);

        headers.push({
          text: getName(columnNames, value),
          value: value,
          textValue: getName(columnNames, value) + " (" + value + ")",
          type: types[0],
          types: types,
          show: true
        });
      }
    });
  }

  return headers.sort(function(a, b) {
    if (a.text < b.text) {
      return -1;
    }
    if (a.text > b.text) {
      return 1;
    }

    // names must be equal
    return 0;
  });
}

function transformPaste(dataSource) {
  return new Promise(function(resolve, reject) {
    config.complete = function(result) {
      const data = result.data;
      const headers = extractHeaders(data);
      resolve({
        headers: headers,
        data: data
      });
    };
    config.error = function(err) {
      reject(new Error(err));
    };

    // Papa.parse(dataSource.input, config);


  });
}




export function transformSQL(dataSource, dataSources) {

  return new Promise(function(resolve, reject) {
    resolve();
    /**
    const query = createSQL(dataSource, dataSources);
    alasql([
      [query.sql, query.parameters]
    ]).then(function(result) {
      const data = result[0];
      const headers = extractHeaders(data);
      resolve({
        headers: headers,
        data: data
      });
    }).catch(function(err) {

      reject(new Error(err));
    });**/

  });
}


function getMatches(string, regex, index) {
  index || (index = 1); // default to the first capturing group
  let matches = [];
  let match;
  while (match = regex.exec(string)) {
    matches.push({
      group: match[1],
      full: match[0]
    });
  }
  return matches;
}

export function extractWorkSheetsInfo(sql) {
  const regex = /worksheet\((.*?)\)/gim;
  let matches = getMatches(sql, regex);
  return matches;
}

export function createDataSourceFromUrl(url) {

}

function removeNativeFields(input) {

}

export function dashboardModel1(cls) {
  let columns = cls;

  columns.sort(function(a, b) {
    return b.type.points - a.type.points;
  });

  let groupColumn = null;
  let dateColumn = null;
  let listColumn = null;
  let valueColumn = null;

  for (let i = 0; i < columns.length; i++) {
    const column = columns[i];
    // pick firts organisation
    // console.log(column.name, column.type);

    if (!groupColumn && column.type.type == "organisation" && column.distinctCount >= 2 && column.distinctCount < 30) {
      groupColumn = column;
    }
    if (!groupColumn && column.type.type == "location" && column.distinctCount >= 2 && column.distinctCount < 30) {
      groupColumn = column;
    }
    if (!groupColumn && column.type.type == "department" && column.distinctCount >= 2 && column.distinctCount < 30) {
      groupColumn = column;
    }
    // pick first date
    if (!dateColumn && column.type.type == "date" && column.distinctCount > 4) {
      dateColumn = column;
    }
    if (!listColumn && column.type.type == "person" && column.distinctCount > 3) {
      listColumn = column;
    }
    if (!listColumn && column.type.type == "location" && column.distinctCount > 3) {
      listColumn = column;
    }
    if (!listColumn && column.type.type == "department" && column.distinctCount > 3) {
      listColumn = column;
    }
    // name column
    if (!valueColumn && column.type.type == "numeric") {
      valueColumn = column;
    }
  }
  if (groupColumn && dateColumn && listColumn && valueColumn) {
    return {
      model: 'company-summary',
      columns: {
        group: groupColumn,
        date: dateColumn,
        list: listColumn,
        value: valueColumn
      }
    };
  }
  return null;
}


export function dashboardModel2(cls) {
  let columns = cls;

  columns.sort(function(a, b) {
    return b.type.points - a.type.points;
  });

  let groupColumn = null;
  let itemColumn = null;
  let listColumn = null;
  let valueColumn = null;

  for (let i = 0; i < columns.length; i++) {
    const column = columns[i];
    // pick firts organisation
    // console.log(column.name, column.type);

    if (!groupColumn && column.type.type == "organisation" && column.distinctCount > 2 && column.distinctCount < 30) {
      groupColumn = column;
    }
    if (!groupColumn && column.type.type == "location" && column.distinctCount > 2 && column.distinctCount < 30) {
      groupColumn = column;
    }
    if (!groupColumn && column.type.type == "department" && column.distinctCount > 2 && column.distinctCount < 30) {
      groupColumn = column;
    }
    // pick first date
    if (!itemColumn && column.type.type == "organisation" && column.distinctCount > 2 && column.distinctCount < 30) {
      itemColumn = column;
    }
    if (!itemColumn && column.type.type == "location" && column.distinctCount > 2 && column.distinctCount < 30) {
      itemColumn = column;
    }
    if (!itemColumn && column.type.type == "department" && column.distinctCount > 2 && column.distinctCount < 30) {
      itemColumn = column;
    }

    if (!listColumn && column.type.type == "person" && column.distinctCount > 3) {
      listColumn = column;
    }
    if (!listColumn && column.type.type == "location" && column.distinctCount > 3) {
      listColumn = column;
    }
    if (!listColumn && column.type.type == "department" && column.distinctCount > 2) {
      listColumn = column;
    }
    // name column
    if (!valueColumn && column.type.type == "numeric") {
      valueColumn = column;
    }
    if (column.type.type == "numeric") {
      if(column.name.toLowerCase().includes("income")) {
        valueColumn = column;
      } else if(column.name.toLowerCase().includes("profit")) {
        valueColumn = column;
      } else if(column.name.toLowerCase().includes("sales")) {
        valueColumn = column;
      } else if(column.name.toLowerCase().includes("revenue")) {
        valueColumn = column;
      } else if(column.name.toLowerCase().includes("hours")) {
        valueColumn = column;
      }

    }

  }
  if (groupColumn && itemColumn && listColumn && valueColumn) {
    console.log("found it");
    return {
      model: 'company-summary-without-date',
      columns: {
        group: groupColumn,
        item: itemColumn,
        list: listColumn,
        value: valueColumn
      }
    };
  }
  console.log( {
    model: 'company-summary-without-date',
    columns: {
      group: groupColumn,
      date: itemColumn,
      list: listColumn,
      value: valueColumn
    }
  });
  return null;
}

export function recommendDashboard(columns) {
  let dashboard1 = dashboardModel1(columns);
  if(dashboard1 == null) {

    dashboard1 = dashboardModel2(columns);
    console.log("found model 2", dashboard1);
  }
  return dashboard1;
}

export function buildHierachy(data, columnNames, distinctCounts) {
  if (!data.length) {
    return [];
  }
  // get header
  let headers = Object.keys(data[0]).filter(function(value) {
    return !value.startsWith("_native")
  });
  let columns = [];
  // console.log(headers);
  for (var i = 0; i < headers.length; i++) {
    const name = headers[i];
    if (typeof columnNames[name] == "undefined") {
      continue;
    }
    if (typeof distinctCounts[name] == "undefined") {
      continue;
    }

    let column = {...columnNames[name]};

    column.values = [...new Set(data.map((row) => {
      return row[name];
    }))];
    column.size = column.values.length;
    const types = getType(column.field, data, 100, column.name);
    column.type = types[0];
    column.distinctCount = distinctCounts[name];
    // delete column.values;
    // console.log("name is", name);
    // console.log("column", column);
    columns.push(column);

  }

  // console.log(columns);

  return columns.sort(function(a, b) {
    return b.points - a.points;
  });

}

function createSQL(dataSource, dataSources) {
  const worksheetsInfo = extractWorkSheetsInfo(dataSource.input);
  let parameters = [];
  let input = dataSource.input;
  worksheetsInfo.forEach(function(info) {
    let name = trimName(info.group);

    let d = dataSources.find(d => trimName(d.name) === name);
    if (d) {
      input = input.replace(info.full, "?")
      parameters.push(d.data);
    }
  });
  return {
    sql: input,
    parameters: parameters
  };
}

function hydrateDb(dataSource) {

  const input = JSON.stringify(dataSource.input);
  return {
    id: dataSource.id,
    name: trimName(dataSource.name),
    type: dataSource.type,
    description: dataSource.description,
    columnId: dataSource.columnId,
    baseQuery: dataSource.baseQuery,
    projectId: dataSource.projectId,
    input: (input.length <= 1000000) ? input : '',
    //content: JSON.stringify(dataSource.data),
    content: "{}",
    options: JSON.stringify(dataSource.options)
  }
}


// function encode(data) {
//   return window.btoa(JSON.stringify(data));
// }

function updateProjectDate() {

}

// function decode(data) {
//   return JSON.parse(window.atob(data));
// }

function hydrateApiInput(dataSource) {
  const input = encode(dataSource.input);
  //console.log('dataSource.options', dataSource.options.selectedFields);
  //console.log('dataSource.options', JSON.stringify(dataSource.options));
  return {
    id: dataSource.id,
    userId: dataSource.userId,
    name: trimName(dataSource.name),
    type: dataSource.type,
    description: dataSource.description,
    baseQuery: dataSource.baseQuery,
    // columnId: dataSource.columnId,
    projectId: dataSource.projectId,
    // schema: (input.length <= 100000000) ? input : '',
    schema: "{}",
    // schema: input,
    content: "{}",
    // content: encode(dataSource.data),
    options: encode(dataSource.options)
  }
}

export async function getLiveDataSources(params, fetch = false) {
  // console.log('datasource table', table);
  fetch = true;
  const datasources = null;

  params.status = 'live';

  // const id = "datasources" + JSON.stringify(params);
  // const datasources = await db[responseTable].get(id);
  // fetch = true;
  // console.log(datasources);
  try {
    if (datasources && fetch == false) {
      return hydrateApiDataSources(JSON.parse(datasources.content).data);
    } else {
      const response = await ApiService.query('/datasource/search/findByProjectAndStatusId', {
        params: params
      });
      //  await db[responseTable].delete(id);
      //  await db[responseTable].put({id: id, content: JSON.stringify(response)});
      return hydrateApiDataSources(response.data);
    }

    //return hydrateDataSources(await db[table].where("projectId").equals(projectId).toArray());
  } catch (err) {
    console.log(err);
    return [];
  }
}

export async function getTables(params) {

  const response = await ApiService.query('/datasource/tables', {
    params: params
  });

  return response.data;

}

export async function getDataSources(params, fetch = false) {
  // console.log('datasource table', table);
  //fetch = true;
  // let datasources = null;
  const key = "getDataSources_" + params.projectId;
  let datasources = getFromStorage(key);
  if(fetch != true && datasources) {
    return hydrateApiDataSources(JSON.parse(datasources));
  }
  // const id = "datasources" + JSON.stringify(params);
  // const datasources = await db[responseTable].get(id);
  // fetch = true;
  // console.log(datasources);

  try {
    if (datasources && fetch == false) {
      return hydrateApiDataSources(JSON.parse(datasources.content).data);
    } else {
      const response = await ApiService.query('/datasource/search/findByProjectId', {
        params: params
      });
      //  await db[responseTable].delete(id);
      //  await db[responseTable].put({id: id, content: JSON.stringify(response)});
      saveInStorage(key, JSON.stringify(response.data))
      return hydrateApiDataSources(response.data);
    }

    //return hydrateDataSources(await db[table].where("projectId").equals(projectId).toArray());
  } catch (err) {
    console.log(err);
    return [];
  }
}




export function hydrateApiDataSources(response) {
  const dataSources = response;
  let result = [];
  dataSources.forEach(function(dataSource) {
    result.push(new DataSource(dataSource))
  });
  return result;
}

export function hydrateDataSources(dataSources) {
  let result = [];
  dataSources.forEach(function(dataSource) {
    result.push(new DataSource(dataSource))
  });
  return result;
}

export async function mergeDataSource(dataSource) {
  const payload = hydrateApiInput(dataSource);
  dataSource.saveInStorage();
  const ids = dataSource.childrenIds.map(function(id) {
    return id
  }).join(",");
  if(ids) {
    const response = await ApiService.get('/datasource/merge/' + dataSource.id + "/" + ids);
  } else {
    const response = await ApiService.get('/datasource/deletemerge/' + dataSource.id);
  }

  // return new DataSource(response.data);
  // return getDataSources({projectId: dataSource.projectId});
  // return await db[table].put(hydrateDb(dataSource))
}

export async function addDataSource(dataSource) {
  let key = "getDataSources_" + dataSource.projectId;
  removeFromStorage(key);
  const payload = hydrateApiInput(dataSource);
  const response = await ApiService.post('/datasource', payload);
  let d = await new DataSource(response.data);
  d.saveInStorage();
  return d;
  // return getDataSources({projectId: dataSource.projectId});
  // return await db[table].put(hydrateDb(dataSource))
}

export async function updateDataSource(dataSource) {
  let key = "getDataSources_" + dataSource.projectId;
  removeFromStorage(key);
  const payload = hydrateApiInput(dataSource);
  delete payload.id;
  let response =  await ApiService.update('/datasource', dataSource.id, payload);
  // console.log("updated " + response);
  let d = await new DataSource(response.data);
  d.saveInStorage();
  return d;
  // return await db[table].update(dataSource.id, hydrateDb(dataSource))
}

export async function deleteDataSource(dataSource) {
  let key = "getDataSources_" + dataSource.projectId;
  removeFromStorage(key);
  return await ApiService.delete('/datasource/' + dataSource.id);
  // return await db[table].delete(dataSource.id)
}

export {
  transformPaste,
  createSQL
};
